<template>
  <div class="cp-steps steps">
    <Title markup="h5" size="XL" alt>Marche à suivre:</Title>
    <ul class="steps__items">
      <li
        v-for="(step, idx) in steps"
        :key="'step' + idx"
        class="step"
        :class="{ 'step--group': step.title }"
      >
        <span class="step__number">{{ idx + 1 }}</span>
        <span class="step__content">
          <h3 class="step__title" v-if="step.title">
            <span>{{ step.title }}</span>
          </h3>
          <span class="step__desc">
            <component v-bind:is="doShortcode(step.content)"></component>
          </span>
        </span>
      </li>
    </ul>
  </div>
</template>
<script>
import Title from "@/components/ui/Title.vue";
export default {
  name: "Steps",
  components: { Title },
  props: {
    steps: Array,
    nbPerson: Number,
    counter: Number
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss">
.steps {
  &__items {
    padding: 0;
    margin: 20px 0;
  }
}
.step {
  display: flex;
  margin-top: 40px;
  &--group {
    margin-top: 80px;
  }
  &__number {
    @include font-title();
    color: rgba($primary, 1);
    font-size: 23px;
    border-right: 1px solid rgba($primary, 0.4);
    padding-right: 7px;
    margin-right: 7px;
    line-height: 0.9;
    width: 0.8em;
  }
  &__title {
    margin: 0;
    font-size: 1em;
    margin-top: -40px;
    margin-bottom: 15px;
    span {
      font-family: omnes-pro, sans-serif;
      display: inline-block;
      border-bottom: 1px solid $black;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.08em;
    }
  }
  &__desc {
    line-height: 1.4;
  }
}
</style>
